import { FlowCardLoading } from '@components/FlowCard'
import { SetMarqetaPin } from '@components/RouteComponents'
import { createFileRoute } from '@tanstack/react-router'

import { ensureUserTermsQueryData } from '../-utils/ensureUserTermsQueryData'

export const Route = createFileRoute('/_initialized/setMarqetaPin')({
  loader: ({ context }) => ensureUserTermsQueryData(context),
  component: SetMarqetaPin,
  pendingComponent: FlowCardLoading,
})
